import type React from "react";
import type { Asset } from "../../types/public-types";
import styles from "./asset-list-table.module.css";

export const AssetListTableDefault: React.FC<{
  rowHeight: number;
  rowWidth: number;
  fontFamily: string;
  fontSize: string;
  assets: Asset[];
  selectedAssetId: string;
  setSelectedAsset: (assetId: string) => void;
}> = ({ rowHeight, rowWidth, fontFamily, fontSize, assets }) => {
  const headerX: number = 0;
  const cellPadding: number = 0.1;

  // Calculate cumulative heights and total height
  const assetYOffsets: number[] = [];
  let cumulativeHeight = 0;
  assets.forEach((asset, i) => {
    assetYOffsets[i] = cumulativeHeight;
    const assetRowHeight = asset.rowHeight || rowHeight;
    cumulativeHeight += assetRowHeight;
  });
  const totalHeight = cumulativeHeight;

  return (
    <g>
      <rect
        x={headerX}
        y={0}
        width={rowWidth}
        height={totalHeight}
        className={styles.graphicWrapper}
      />
      {assets.map((t, index) => {
        const assetRowHeight = t.rowHeight || rowHeight;
        const yPosition = assetYOffsets[index];

        return (
          <g key={`${t.id}g`}>
            <rect
              key={`${t.id}row`}
              x={headerX}
              y={yPosition}
              width={rowWidth}
              height={assetRowHeight}
              className={
                index % 2 === 0 ? styles.graphicRow : styles.graphicRowAlt
              }
            ></rect>
            <rect
              key={`${t.id}cell`}
              x={headerX + cellPadding * rowWidth}
              y={yPosition + cellPadding * assetRowHeight}
              width={rowWidth * (1 - cellPadding * 2)}
              height={assetRowHeight * (1 - cellPadding * 2)}
              className={styles.graphicCell}
              style={{ fill: t.color }}
            ></rect>
            <text
              key={`${t.id}text`}
              x={headerX + rowWidth * 0.5}
              y={yPosition + assetRowHeight * 0.5}
              className={styles.graphicLabel}
              style={{
                fontFamily: fontFamily,
                fontSize: 20,
                fill: "black",
              }}
            >
              {t.name}
            </text>
          </g>
        );
      })}
    </g>
  );
};
